import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Section, Title } from 'components/misc'
import { Col, List, ListTitle, Lists } from './styled'

export const Names = forwardRef<HTMLDivElement, {}>((_, ref) => (
  <Section ref={ref}>
    <TextContainer>
      <Title data-menu-title="имена">Имена</Title>

      <p>
        В Республике Саха существует традиция параллельного использования русских и национальных имен. При колонизации Сибири в XVII веке коренные народы массово русифицировали и обращали в христианство. Это привело к вымещению традиционных имен в официальных контекстах. Несмотря на это, в быту или личном общении их продолжали использовать.
      </p>
      <p>
        Большая часть имен саха сегодня остаются русскими, но их звучание было адаптировано к языку саха. В официальных документах используется русское написание имен, но в литературе допускается адаптированное написание. Только в 2012 году в Республике Саха приняли{' '}
        <a
          href="https://rg.ru/documents/2012/07/02/yakutiya-zakon1031-reg-dok.html"
          target="_blank"
          rel="noreferrer"
        >
          закон
        </a>
        , который позволил вместо русифицированных фамилий и имен снова брать родовые.
      </p>

      <Lists>
        <Col>
          <ListTitle>Мужские имена:</ListTitle>
          <List>
            <div>
              <dt>Бөчөөх</dt>
              <dd>волчонок</dd>
            </div>
            <div>
              <dt>Кэнчээри</dt>
              <dd>счастливый</dd>
            </div>
            <div>
              <dt>Өктөм</dt>
              <dd>здоровый и крепкий</dd>
            </div>
            <div>
              <dt>Чаҕыл</dt>
              <dd>молния</dd>
            </div>
            <div>
              <dt>Хотой</dt>
              <dd>сильный как сокол</dd>
            </div>
            <div>
              <dt>Эрэл</dt>
              <dd>сприносящий добро</dd>
            </div>
          </List>
        </Col>
        <Col>
          <ListTitle>Женские имена:</ListTitle>
          <List>
            <div>
              <dt>Айталыына</dt>
              <dd>чистая как Луна</dd>
            </div>
            <div>
              <dt>Күн</dt>
              <dd>солнце</dd>
            </div>
            <div>
              <dt>Күөрэгэй</dt>
              <dd>голосящая как жаворонок</dd>
            </div>
            <div>
              <dt>Нарияна</dt>
              <dd>нежная</dd>
            </div>
            <div>
              <dt>Ньургуһун</dt>
              <dd>красивая как цветок</dd>
            </div>
            <div>
              <dt>Сайдыына</dt>
              <dd> с доброй душой</dd>
            </div>
          </List>
        </Col>
      </Lists>
    </TextContainer>
  </Section>
))
